import { Tracker } from '@lib/tracking/Tracker'

const DOM_READY =
  typeof window === 'undefined'
    ? Promise.resolve()
    : new Promise((resolve) =>
      window.addEventListener('DOMContentLoaded', resolve, { once: true })
    )

function getAnalyticsConfig (trackerConfigs, utsId) {
  const analytics = trackerConfigs?.uts
  if (!analytics || !utsId) return undefined

  analytics.context.utsId = utsId
  analytics.trackingId = trackerConfigs.trackingId
  return analytics
}

// UTS - has been integrated with LIFF
// https://git.linecorp.com/UTS/uts-sdk-js
// https://git.linecorp.com/LIFF/liff-sdk/blob/main/doc/Public-API.md#liffanalytics
export default class UTS implements Tracker {
  _ready: Promise<void>
  _trackingId: string

  constructor (trackerConfigs, utsId) {
    this._ready = DOM_READY.then(() => {
      try {
        if (!window.uts) throw new Error('Has been blocked by AD blocker.')

        const analytics = getAnalyticsConfig(trackerConfigs, utsId)
        if (!analytics) throw new Error('No UTS configuration.')

        const { context, options, trackingId } = analytics
        window.uts.init(context, options)
        this._trackingId = trackingId
      } catch (e) {
        console.error('[Tracker] UTS init issue ->', e)
        throw e
      }
    })
  }

  load () {
    return this._ready
  }

  pageView ({ event, options, callback }) {
    this._ready.then(() => {
      const _event = { ...event }
      _event.params = { ...event.params, tracking_id: this._trackingId }
      window.uts?.sendPageview(_event, options, callback)
    })
  }

  event ({ config, event, options, callback }) {
    this._ready.then(() => {
      const _event = { ...event }
      _event.params = { ...event.params, tracking_id: this._trackingId }
      window.uts?.send(config?.utsType || 'click', _event, options, callback)
    })
  }

  push (data) {
    // Not support
  }

  set (key, ...values) {
    this._ready.then(() => uts.set({ [key]: values[0] }))
  }
}
